/* eslint-disable no-undef,no-unused-vars */

// Utils
import ErrorUtil from '@/utils/ErrorUtil';

// Resources
import LabelResource from '@/resources/LabelPrinting/xml';
// DymoLabelFramework IS being used! It's supplying 'dymo' globally to whatever page this is being imported on!
import DymoLabelFramework from '@/resources/LabelPrinting/DymoLabelFramework';

import OmniprintApi from '../api/OmniprintApi';

const REUSED_ERROR_MESSAGE = 'No DYMO Label printer found and/or SDK is not Installed';

/**
 * @returns { Object } - a DYMO Printer Object
 * @throws { Error } - A generic error
 */
async function getConnectedPrinter() {
    // eslint-disable-next-line no-use-before-define
    const printerList = await getConnectedPrinters();
    // eslint-disable-next-line no-plusplus
    for ( let i = 0; i < printerList.length; i++ ) {
        if ( printerList[ i ].isConnected ) {
            return printerList[ i ];
        }
    }
    throw new Error( REUSED_ERROR_MESSAGE );
}

async function getConnectedPrinters() {
    return dymo.label.framework.getPrinters();
}

async function printToDymo( filename ) {
    try {
        const selectedPrinter = await getConnectedPrinter();
        const label = await dymo.label.framework.openLabelXml( await LabelResource.defaultLabelXML() );
        const pngImage = await dymo.label.framework.loadImageAsPngBase64( filename );
        label.setObjectText( 'Image', pngImage );
        label.print( selectedPrinter.name );
    } catch ( error ) {
        console.error( `Unable to print to Dymo service:${ error }` );
    }
}

async function printLabel( filename ) {
    try {
        await OmniprintApi.checkHealth();
        OmniprintApi.printLabel( filename );
    } catch ( error ) {
        console.error( `Unable to print to Omniprint service: ${ error }` );
        await printToDymo( filename );
    }
}

export default {
    printLabel,
    getConnectedPrinter,
    getConnectedPrinters,
};
